import { render } from "./EasyPOSAir.vue?vue&type=template&id=1d4f894e&scoped=true"
import script from "./EasyPOSAir.vue?vue&type=script&lang=js"
export * from "./EasyPOSAir.vue?vue&type=script&lang=js"

import "./EasyPOSAir.vue?vue&type=style&index=0&id=1d4f894e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d4f894e"]])

export default __exports__